import React from 'react';
import { MapPin, Phone, MessageCircle, Instagram, ExternalLink } from 'lucide-react';
import { siteData } from '../data/siteData';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const Contact = () => {
  return (
    <section id="contacto" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 py-1.5 bg-[var(--color-purple)]/10 text-[var(--color-purple)] text-sm font-medium rounded-full mb-4">
            Encontranos
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--text-primary)] mb-4">
            Nuestras sucursales
          </h2>
          <p className="text-lg text-[var(--text-secondary)] max-w-2xl mx-auto">
            Elegí la ubicación más conveniente para vos y reservá tu turno.
          </p>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
          {siteData.locations.map((location, index) => (
            <Card
              key={location.id}
              className={`overflow-hidden border-2 ${
                index === 0
                  ? 'border-[var(--color-magenta)]/20 bg-gradient-to-br from-[var(--color-magenta)]/5 to-transparent'
                  : 'border-[var(--color-cyan)]/20 bg-gradient-to-br from-[var(--color-cyan)]/5 to-transparent'
              }`}
            >
              <CardContent className="p-6 sm:p-8">
                <div className="flex items-start gap-4 mb-6">
                  <div
                    className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center ${
                      index === 0 ? 'bg-[var(--color-magenta)]' : 'bg-[var(--color-cyan)]'
                    }`}
                  >
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-semibold text-[var(--text-primary)]">
                      {location.city}
                    </h3>
                    <p className="text-[var(--text-secondary)]">{location.address}</p>
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  <a
                    href={`tel:${location.phone.replace(/\s/g, '')}`}
                    className="flex items-center gap-3 text-[var(--text-secondary)] hover:text-[var(--color-magenta)] transition-colors"
                  >
                    <Phone className="w-5 h-5" />
                    <span>{location.phone}</span>
                  </a>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <Button
                    asChild
                    className={`flex-1 ${
                      index === 0
                        ? 'bg-[var(--color-magenta)] hover:bg-[var(--color-purple)]'
                        : 'bg-[var(--color-cyan)] hover:bg-[var(--color-purple)]'
                    } text-white`}
                  >
                    <a
                      href={location.whatsapp}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2"
                    >
                      <MessageCircle className="w-5 h-5" />
                      WhatsApp
                    </a>
                  </Button>
                  {location.mapsUrl && (
                    <Button
                      asChild
                      variant="outline"
                      className="flex-1 border-2"
                    >
                      <a
                        href={location.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2"
                      >
                        <ExternalLink className="w-5 h-5" />
                        Cómo llegar
                      </a>
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Instagram CTA */}
        <div className="text-center">
          <Card className="inline-block bg-gradient-to-r from-[var(--color-magenta)]/10 via-[var(--color-purple)]/10 to-[var(--color-cyan)]/10 border-0">
            <CardContent className="p-6 sm:p-8">
              <Instagram className="w-10 h-10 text-[var(--color-magenta)] mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-[var(--text-primary)] mb-2">
                Seguinos en Instagram
              </h3>
              <p className="text-[var(--text-secondary)] mb-4">
                Mirá nuestros trabajos y novedades
              </p>
              <Button
                asChild
                variant="outline"
                className="border-2 border-[var(--color-magenta)] text-[var(--color-magenta)] hover:bg-[var(--color-magenta)] hover:text-white"
              >
                <a
                  href={siteData.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <Instagram className="w-5 h-5" />
                  {siteData.social.instagramHandle}
                </a>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;
